import { useEffect } from "react";
import { usePathname } from '#app/lib/hooks/router-compat';
import { checkForUpdate } from "./version-check";

export function useVersionCheck(): void {
  const pathname = usePathname();

  useEffect(() => {
    checkForUpdate();
  }, [pathname]);

  useEffect(() => {
    function onVisibilityChange() {
      if (document.visibilityState === "visible") {
        checkForUpdate();
      }
    }
    document.addEventListener("visibilitychange", onVisibilityChange);
    return () => document.removeEventListener("visibilitychange", onVisibilityChange);
  }, []);
}
